<script>
  // Moderation report disclosure. `value` is the row's reports array (AdminSite::ReportRows:
  // unreviewed first, each group oldest first; `reporter.url` built server-side). The cell shows the
  // unreviewed count plus the age of the oldest unreviewed report; clicking it opens
  // the per-report rows so a moderator can see WHY something was reported. A modal
  // (not an in-table expand row) so the same cell works in table and card-grid views.
  //   { slot:'metadata', field:'moment_reports', label:'Reports', renderer:'report_summary' }
  import { Link } from '@inertiajs/svelte'
  import dayjs from 'dayjs'
  import Modal from '../../modal.svelte'
  import Badge from '../../ui/badge.svelte'
  import Icon from '../../ui/icon.svelte'
  import AgeBadge from '../../badges/age_badge.svelte'

  let { value } = $props()

  let open = $state(false)

  const reports = $derived(value || [])
  const unreviewed = $derived(reports.filter((report) => !report.reviewed))
  const oldestUnreviewedAt = $derived(unreviewed[0]?.created_at ?? null)
  const countLabel = $derived(
    unreviewed.length > 0 ? `${unreviewed.length} unreviewed` : `${reports.length} reviewed`
  )

  const formatTime = (timestamp) => dayjs(timestamp).format('MMM D, YYYY h:mm A')
</script>

{#if reports.length === 0}
  <span class="text-base-content/40">—</span>
{:else}
  <button
    type="button"
    class="inline-flex flex-wrap items-center gap-x-2 gap-y-1 text-left link link-hover"
    title="Show report details"
    aria-haspopup="dialog"
    onclick={() => (open = true)}
  >
    <Icon name="user_reports" size="sm" class={unreviewed.length > 0 ? 'text-warning' : 'text-base-content/40'} />
    <span>{countLabel}</span>
    <AgeBadge timestamp={oldestUnreviewedAt} staleAfterHours={24} criticalAfterHours={72} />
  </button>

  {#if open}
    <Modal bind:open title={reports.length === 1 ? '1 report' : `${reports.length} reports`}>
      <ul class="flex flex-col gap-3 text-left text-sm whitespace-normal">
        {#each reports as report (report.id)}
          <li class="rounded-box border border-base-300 p-3">
            <div class="flex flex-wrap items-center justify-between gap-2">
              <span class="font-medium">{report.reason_label || report.reason || '—'}</span>
              {#if report.reviewed}
                <Badge variant="success" soft size="sm">Reviewed</Badge>
              {:else}
                <Badge variant="warning" size="sm">Unreviewed</Badge>
              {/if}
            </div>
            <p class="mt-2 break-words {report.details ? '' : 'text-base-content/40'}">{report.details || '—'}</p>
            <div class="mt-2 text-xs text-base-content/60">
              by
              {#if report.reporter?.url}
                <Link href={report.reporter.url} class="link link-hover">{report.reporter.name || 'Unknown'}</Link>
              {:else}
                Unknown
              {/if}
              · {formatTime(report.created_at)}
              {#if report.reviewed && report.reviewed_at}
                · reviewed{#if report.reviewed_by?.name}&nbsp;by {report.reviewed_by.name}{/if} on {formatTime(report.reviewed_at)}
              {/if}
            </div>
          </li>
        {/each}
      </ul>
    </Modal>
  {/if}
{/if}
